var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 18.0002H4.16665C3.70641 18.0002 3.33331 17.6272 3.33331 17.1669V9.66691H0.833313L9.4394 1.84318C9.75723 1.55423 10.2427 1.55423 10.5606 1.84318L19.1666 9.66691H16.6666V17.1669C16.6666 17.6272 16.2936 18.0002 15.8333 18.0002ZM4.99998 16.3336H15V8.13147L9.99998 3.58601L4.99998 8.13147V16.3336ZM9.99998 13.0002C8.8494 13.0002 7.91665 12.0675 7.91665 10.9169C7.91665 9.76633 8.8494 8.83358 9.99998 8.83358C11.1506 8.83358 12.0833 9.76633 12.0833 10.9169C12.0833 12.0675 11.1506 13.0002 9.99998 13.0002Z",
    fill: "#6F7376"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.6a18cc93e6ba2c6138f652fb2e4df900.svg";
export { ForwardRef as ReactComponent };